import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import ReportingPeriodForm from "./ReportingPeriodForm";

export interface State {}

export interface CreateReportingPeriodFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  codebooks: any[];
}

class CreateReportingPeriodForm extends React.Component<
  CreateReportingPeriodFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newReportingPeriodData = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newReportingPeriodData = values;
        }
      });
      return newReportingPeriodData;
    });
  }

  render() {
    const { translate, codebooks } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <ReportingPeriodForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        codebooks={codebooks}
      />
    );
  }
}

export default CreateReportingPeriodForm;
